import { Grid, Typography } from '@mui/material';
import { getAppLogo } from '../../../utils/getAppLogo';
import { useMUITheme } from "../../../theme/ThemeProvider";
import React from 'react';

interface IForgotPasswordButton {
  maintenanceSchedule: { maintenanceActive: boolean }
  setUserName: React.Dispatch<boolean>
  setStartMFAFlow: React.Dispatch<boolean>
  setOpenAlert: React.Dispatch<boolean>
  setSeverity: React.Dispatch<string>
  stateLogo: string
}

const ForgotPasswordButton: React.FC<IForgotPasswordButton> = ({ maintenanceSchedule, setUserName, setStartMFAFlow, setOpenAlert, setSeverity, stateLogo }) => {
  const getUserName = () => {
    setUserName(true)
    setStartMFAFlow(true);
    setOpenAlert(false)
    setSeverity("")
  };

  const pressForgotPW = (e: any) => {
    setUserName(true);
    setOpenAlert(false)
    setSeverity("")
    setStartMFAFlow(true);
  }

  const { mode } = useMUITheme();
  const isDark = mode === 'dark';

  return (
    <>
      <Grid item xs={12} >
        <Typography
          variant="body2"
          color='primary'
          data-testid='forgot-password-link'
          onClick={maintenanceSchedule.maintenanceActive ? () => { } : getUserName}
          onKeyPress={pressForgotPW}
          tabIndex={0}
          sx={{ textDecoration: 'underline', '&:hover': { cursor: maintenanceSchedule.maintenanceActive ? 'not-allowed' : 'pointer' } }}>
          Forgot Password?
        </Typography>
      </Grid>
      <Grid container justifyContent='center' alignItems='center' direction='column' mt='0.5rem'>
        <Typography variant="h3" color='text.primary' sx={{ mb: '0.5rem' }}>{stateLogo}</Typography>
        <img src={getAppLogo(isDark)} style={{ width: '120px' }} alt='State logo' />
      </Grid>
    </>
  )
}

export default ForgotPasswordButton;